module.exports = __webpack_public_path__ + "img/icon-copy.5c4ddd52.svg";